function SignalHighResolution() {
    /// <summary>
    /// This object provides common functions for the Widget.Signal.SignalAnalog.HighResolution.vb <br/>
    /// Author: ARF<br />
    /// Date: 30.9.2019<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 9.10.2019                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bInit = false;
    
}
SignalHighResolution.prototype = new vcTemplate();

SignalHighResolution.prototype.init = function () {
    /// <summary>
    /// This function inits the calendar, the left menu and sets some heights.
    /// </summary>
    var me = this;
    var h;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        //add the save handler
        me.visual.find("#div-btn-save").off("click").on("click", function () { me.save($(this)); }).button().button("disable");

        //adjust the height of the data list
        h = me.height;
        h = h - parseInt(me.visual.find("#div-menu").height() + me.visual.find(".vc-list-header").height() + me.visual.find("#div-select-all").height() + 55);
        me.visual.find("#ul-entries").css("max-height", h);

        //get some values
        me.fetch();
      //add the click/change handlers in the list
        me.visual.find("#ul-entries").off("click", ".chb").on("click", ".chb", function() { me.edit($(this)); });
        me.visual.find("#ul-entries").off("change", ".ddl").on("change",".ddl", function () {me.edit($(this)); });

        //add the change handlers for the default values
        //optionaly they will overwrite all existing entries in the list
        me.visual.find("#ddl-default-len").off("change").on("change", function() {
            me.overwriteAll(".col1", $(this));
            me.validateAll();
        });
        me.visual.find("#ddl-default-interval").off("change").on("change", function () {
            me.overwriteAll(".col2", $(this));
            me.validateAll();
        });

        me.visual.find("#ddl-default-level").off("change").on("change", function () {
            me.overwriteAll(".col3", $(this));
            me.validateAll();
        });

        //init filter
        me.visual.find("#div-filter").vcFilter({ callback: function () { me.filter(); } });
        //init select all chb
        me.visual.find('#chb-select-all').off("click").on('click', function () {me.selectAll(); });

    
        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


SignalHighResolution.prototype.selectAll = function () {
    /// <summary>
    /// This function selects/unselects all entries and sets the values
    /// </summary>
    var me = this;
    try {


        if (me.visual.find('#chb-select-all').prop('checked')) {
            me.visual.find("#ul-entries li .chb").prop("checked", true);
           
        } else {
          
            me.visual.find("#ul-entries li .chb").prop("checked", false);
        }
        me.visual.find("#ul-entries li.found").each(function() {
            me.edit($(this).find(".chb"));
        });

        return true;
    } catch (ex) { me.writeError('selectAll', ex); return false; }
};

SignalHighResolution.prototype.validateAll = function () {
    /// <summary>
    /// This function iterates all acitve entries and marks invalid ddl as invalud.
    /// </summary>
    var me = this;
    try {

        me.visual.find("#ul-entries li").removeClass("invalid");

        me.visual.find("#ul-entries li").each(function () {
            if (!$(this).hasClass("inactive")) {
                if ($(this).find(".ddl").val() === null  ) {
                    $(this).addClass("invalid");
                }
            }
        });

        return true;
    } catch (ex) { me.writeError('validateAll', ex); return false; }
};

SignalHighResolution.prototype.edit = function (obj) {
    /// <summary>
    /// This function sets the entry as dirty and sets the default values for new entries. 
    /// </summary>
    var me = this;
    var li;
    try {
        if (me.error) {
            return false;
        }

        li = obj.parents(".vc-list-item"); 
        li.removeClass("dirty").addClass("dirty");

        if (li.find(".chb").prop("checked")) {
            if (li.hasClass("inactive")) {
                li.removeClass("inactive");
                li.find(".col1 .ddl").val(me.visual.find("#ddl-default-len").val());
                li.find(".col2 .ddl").val(me.visual.find("#ddl-default-interval").val());
                li.find(".col3 .ddl").val(me.visual.find("#ddl-default-level").val());
            }
        } else {
            li.removeClass("inactive").addClass("inactive");
        }

        me.validateAll();
        me.visual.find("#div-btn-save").button("enable");

        return true;
    } catch (ex) { me.writeError('edit', ex); return false }

}


SignalHighResolution.prototype.fetch = function () {
    /// <summary>
    /// This function fetches the entry list and copies the default ddls into all entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
     
        me.visual.find("#ul-entries").html(me.vcC.getLoadingIcon());


        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, '', me.deviceType, me.langid, "",
            function (result) {
                if (result == null) { alert(me.resources.err_loadData); return false; }
               
                me.visual.find("#ul-entries").html(result);
                me.addDDl(me.visual.find("#ddl-default-len"), ".col1", "len");
                me.addDDl(me.visual.find("#ddl-default-interval"), ".col2", "interval");
                me.addDDl(me.visual.find("#ddl-default-level"), ".col3", "level");
                me.filter();
                me.visual.find("#div-btn-save").button("disable");

                me.validateAll();

                return true;
            });
        return true;
        
    } catch (ex) { me.writeError('fetch', ex); return false }

}

SignalHighResolution.prototype.overwriteAll = function (col, obj) {
    /// <summary>
    /// This function opens an dialog and sets all active/filtered entries to the selected value of the default dropdown.
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);

        me.openAskDialog(me.resources.shouldAllValuesGetOverwritten, "",
            function () {
                me.visual.find("#ul-entries li.found").each(function () {
                    if (!$(this).hasClass("inactive")) {
                        $(this).removeClass("dirty").addClass("dirty");
                        $(this).find(col + " .ddl").val(obj.val());
                    }
                });

            });

        return true;
} catch (ex) { me.writeError('overwriteAll', ex); return false; }
};

SignalHighResolution.prototype.addDDl = function (obj, col, data) {
    /// <summary>
    /// This function clones the default dropdown and copies into all entries. <br/>
    /// Then, it sets the proper entries value. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

                me.visual.find("#ul-entries li").each(function () {
                    var d = obj.clone();
                    d.attr("id", "");

                    $(this).find(col).html(d);
                    if (!$(this).hasClass("inactive")) {
                    
                        $(this).find(col + " .ddl").val($(this).data(data)).attr("id", "");

                    }
                });
        
        return true;

    } catch (ex) { me.writeError('addDDl', ex); return false }

}


SignalHighResolution.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find("#ul-entries .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "#ul-entries .vc-list-item", "found");

        me.visual.find("#ul-entries .vc-list-item.found").show();
        me.visual.find("#ul-entries .vc-list-item").removeClass("alt");
        me.visual.find("#ul-entries .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {me.writeError('filter', ex); return false;}

};



SignalHighResolution.prototype.save = function () {
    /// <summary>
    /// This function inits the save button.<br/>
    ///It iterates all dirty entries and generates the entry list.
    /// </summary>
    var me = this;
    var list = [];
    var editType = -1;
    var saaId = -1;
    var len = -1;
    var interval = -1;
    var level = -1;
    try {
        if (me.error) {
            return false;
        }
        if (me.visual.find("#ul-entries li.invalid").length > 0) {
            alert(me.resources.inputIncomplete);
            return false;
        }

        me.visual.find("#ul-entries li.dirty").each(function() {
            saaId = $(this).data("saaid");

            if (isNaN(saaId)) { saaId = -1 }
            
            if (saaId.length === 0) {
                saaId = -1;
            } else {
                saaId = parseInt(saaId);
            }
          
            if ($(this).find(".col1 .ddl").val().length > 0) {
                len = parseInt($(this).find(".col1 .ddl").val());
            } else {
                len = -1;
            }
          
            if ($(this).find(".col2 .ddl").val().length > 0) {
                interval = parseInt($(this).find(".col2 .ddl").val());
            } else {
                interval = -1;
            }
            if ($(this).find(".col3 .ddl").val() !== null) {
                if ($(this).find(".col3 .ddl").val().length > 0) {
                    level = parseInt($(this).find(".col3 .ddl").val());
                } else {
                   level = -1;
               }
            } else {
                level = -1;
            }

            if ($(this).hasClass("inactive")) {
                editType = 3;//delete
               
            } else {
                if ($(this).data("saaid").length === 0) {
                    editType = 1; //add
                } else {
                    editType = 2; //edit
                }
            }

            list.push({
                "Bsaid": parseInt($(this).data("id")),
                "Bluid": parseInt($(this).data("bluid")),
                "EditType": editType,
                "SaaId": saaId,
                "Len": len,
                "Interval": interval,
                "Level": level
                });
           // 

        });
        if (list.length === 0) {
            me.visual.find("#div-btn-save").removeClass("active");
            return true;
        }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ "list": list }),
            function (result) {
                if (result === false) {
                    alert(me.resources.err_saveData);
                } else {
                    me.fetch();
                    _VCMQ.produce(me.visual, me.vcgid, 'UPDATE_SIGNAL_STATE', "");


                    
                   }
                return true;
            });
        return true;

    } catch (ex) { me.writeError('save', ex); return false }

}


SignalHighResolution.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-menu', "#ul-entries").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


